import { render, staticRenderFns } from "./OutrasRevistas.vue?vue&type=template&id=0fd89ca4&scoped=true"
import script from "./OutrasRevistas.vue?vue&type=script&lang=js"
export * from "./OutrasRevistas.vue?vue&type=script&lang=js"
import style0 from "./OutrasRevistas.vue?vue&type=style&index=0&id=0fd89ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd89ca4",
  null
  
)

export default component.exports